import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { updatePassword } from '@/store/User';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { error } from 'console';

interface ChangePasswordDialogProps {
  pOpen: boolean;
  cancelLabel?: string;
  onClose: () => void;
}

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_\-+=])[A-Za-z\d@$!%*?&#^()_\-+=]{8,}$/;

const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({
  pOpen,
  cancelLabel = 'Cancel',
  onClose,
}) => {
  const [newPassword, setNewPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const dispatch = useDispatch<any>();

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = async () => {
    if (!passwordRegex.test(newPassword)) {
      toast.error(
        '❌ Password must be at least 8 characters and include uppercase, lowercase, a number, and a special character.',
      );
      return;
    }
    onClose();
    const data = {
      newPassword: newPassword,
    };

    const res = await dispatch(updatePassword({ data }));
    if (res.error) {
      console.log(res);
      toast.error(`❌ Password update failed Error: ${res.payload.message}`);
      console.error('Update error:', res.error);
      return ;
    }
  };

  return ( 
    <Dialog
      open={pOpen}
      PaperProps={{
        sx: { borderRadius: '24px', padding: '30px' },
      }}
      onClose={handleClose}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'center', fontSize: 24 }}>
        Change Password
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center' }}>
        <label
          htmlFor='custom-input'
          style={{
            display: 'block',
            textAlign: 'left',
            marginTop: '10px',
            fontWeight: '500',
            color: '#444',
            fontSize: '14px',
          }}
        >
          New Password
        </label>
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder='Enter value'
          style={{
            width: '100%',
            padding: '10px 14px',
            fontSize: '16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            outline: 'none',
            marginBottom: '10px',
            boxSizing: 'border-box',
            transition: 'border-color 0.3s',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#1976d2')}
          onBlur={(e) => (e.target.style.borderColor = '#ccc')}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </DialogContent>

      {/* 👁 Show/Hide Button */}
      <div className='flex justify-end'>
        <button
          type='button'
          onClick={() => setShowPassword(!showPassword)}
          style={{
            background: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            color: '#1976d2',
            padding: '0px 25px',
            marginBottom: '10px'

          }}
        >
          {showPassword ? 'Hide' : 'Show'}
        </button>
      </div>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        <Button
          variant='outlined'
          disabled={!newPassword}
          onClick={handleConfirm}
          sx={{
            textTransform: 'none',
            borderRadius: 100,
            px: 4,
            color: 'black',
            borderColor: 'black',
          }}
        >
          Confirm
        </Button>
        <Button
          variant='contained'
          onClick={handleClose}
          sx={{
            textTransform: 'none',
            borderRadius: 100,
            px: 4,
            bgcolor: '#FF0050',
            '&:hover': { bgcolor: '#E6004F' },
          }}
        >
          {cancelLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
